var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourWinnerMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3986_1000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.5,
    cy: 64.5,
    r: 61,
    fill: "url(#bgRadial)",
    stroke: "#2D2A2B",
    strokeWidth: 5,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6178 42.9837C66.6178 42.9837 70.3971 41.598 71.2789 41.346C72.1608 40.9681 75.9401 23.7093 72.0348 21.5677C68.1295 19.5521 64.6021 31.016 66.6178 42.9837Z",
    fill: "url(#paint0_linear_3986_1000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.035 43.4869C71.2791 43.8648 69.5154 43.4869 69.5154 43.4869C69.5154 43.4869 75.3104 27.8658 73.0428 23.4566C70.7752 19.0474 68.7596 21.567 68.0037 44.2427H66.114L59.1852 44.4947C59.1852 44.4947 51.2486 29.3775 51.7525 26.858C52.2564 24.3384 63.7205 19.4254 71.1532 20.0552C71.1532 20.0552 71.2791 20.0552 71.4051 20.0552C78.8378 20.8111 72.9168 43.1089 72.161 43.6128L72.035 43.4869Z",
    fill: "url(#paint1_linear_3986_1000)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0352 43.4863C71.2793 43.8642 69.5156 43.4863 69.5156 43.4863C69.5156 43.4863 75.3107 27.8652 73.0431 23.4561C70.7754 19.0469 68.7598 21.5664 68.0039 44.2422H66.1143C66.1143 38.3213 66.3662 20.0547 71.1534 20.0547C75.9406 20.0547 71.2793 20.0547 71.4053 20.0547C78.838 20.8105 72.9171 43.1084 72.1612 43.6123L72.0352 43.4863Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8932 24.212C69.5153 25.3457 67.6256 33.6602 69.2633 36.8096C70.901 39.959 74.0505 31.0147 73.6725 26.6055C73.2946 22.1963 71.5309 20.1807 69.8932 24.212Z",
    fill: "#CA2790"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.823 44.4951C60.823 44.4951 54.0201 32.1494 52.8863 29.252C51.8785 26.3545 54.2721 24.3389 54.2721 24.3389L56.2877 23.2051C56.2877 23.2051 54.0201 25.5986 55.2799 30.0078C56.2877 33.5351 61.5788 44.2432 61.5788 44.2432H60.697L60.823 44.4951Z",
    fill: "url(#paint2_linear_3986_1000)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2323 44.2422C65.2323 44.2422 63.5946 30.7627 64.6024 25.9756C65.6102 21.1885 69.2636 20.0547 69.2636 20.0547C69.2636 20.0547 66.744 20.0547 64.4764 20.6846C64.4764 20.6846 62.8387 21.6924 62.0828 25.8496C61.327 30.0068 64.2245 44.4941 64.2245 44.4941H65.3583L65.2323 44.2422Z",
    fill: "url(#paint3_linear_3986_1000)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9406 44.2418C59.9406 44.2418 54.9015 34.7936 56.7912 32.0221C58.6809 29.2506 65.6097 42.3522 65.6097 44.1159H59.9406V44.2418Z",
    fill: "#D42790"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9407 44.2424C60.6966 45.2503 62.5863 41.7229 60.9485 37.3137C58.555 30.511 56.7912 32.0227 56.2873 32.4007C55.7834 32.7786 57.6731 41.345 59.8147 44.2424H59.9407Z",
    fill: "#D42790"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2562 26.8585C50.6185 29.2521 64.3501 26.3546 67.2476 22.4494C70.1451 18.5441 56.4135 20.9376 52.2562 26.8585Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8145 32.6516C58.5547 28.8723 64.7276 32.2736 65.4835 34.6672C66.2394 37.0607 66.1134 40.5881 65.4835 41.092C64.8536 41.5959 60.4444 34.5412 59.8145 32.5256V32.6516Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6182 31.014C66.3662 34.6673 69.5156 25.2191 70.0196 22.6996C70.5235 20.18 69.1377 21.5658 69.1377 21.5658C69.1377 21.5658 66.9961 23.7074 66.4922 31.014H66.6182Z",
    fill: "#D42790"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7996 27.1089C55.9099 27.4868 61.579 30.0063 63.3426 32.1479C65.1063 34.2895 67.4999 25.3452 67.4999 23.8335C67.4999 22.3218 65.1063 24.5893 61.9569 25.7231C58.8074 26.8569 58.4295 26.8569 57.6736 27.1089H57.7996Z",
    fill: "#F36A90"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5702 83.5479C60.5702 83.5479 48.3504 102.948 45.8308 101.814C43.3113 100.681 43.9411 92.8701 42.3034 91.3584C42.1774 91.3584 42.0515 91.1064 41.7995 91.1064C39.28 90.0986 31.7213 91.1064 30.9654 89.5947C30.0835 87.957 45.8308 72.3359 45.8308 72.3359L60.5702 83.5479Z",
    fill: "url(#paint4_linear_3986_1000)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4758 74.3516C48.4758 74.3516 34.4922 88.4609 33.9883 89.2168C33.4844 89.9726 33.4844 90.4766 33.4844 90.4766H38.1456C38.1456 90.4766 38.1456 89.9726 38.2716 89.2168C38.3975 88.4609 51.4993 76.7451 51.4993 76.7451L48.4758 74.3516Z",
    fill: "url(#paint5_linear_3986_1000)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9084 80.0215C55.9084 80.0215 43.5625 95.1386 43.5625 95.2646L44.3184 99.4219C44.3184 99.4219 55.2785 85.9424 58.6799 82.1631L55.9084 80.0215Z",
    fill: "url(#paint6_linear_3986_1000)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7999 90.9799C39.2804 89.9721 31.7217 90.9799 30.9658 89.4682C31.3438 88.3344 39.0284 89.9721 40.5402 89.9721C42.0519 89.9721 41.548 90.476 41.7999 90.9799Z",
    fill: "#600090"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5714 83.5488C60.5714 83.5488 48.3516 102.949 45.832 101.815C47.4697 102.319 56.2882 86.3203 60.5714 83.5488Z",
    fill: "#600090"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9414 95.2636C44.0674 94.3817 47.7207 89.9726 48.2247 89.5946C48.7286 89.2167 50.2403 90.2245 50.6182 90.7284C50.8702 91.2323 45.3271 97.6572 44.8232 98.0351C44.3193 98.413 43.9414 95.2636 43.9414 95.2636Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8942 88.9657C37.0123 88.9657 35.3746 88.9657 35.1227 88.5878C34.8707 88.2098 39.28 83.8007 40.2878 83.1708C41.2956 82.4149 43.4372 82.7928 43.8152 83.1708C44.0671 83.5487 37.8942 88.9657 37.8942 88.9657Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2705 83.5479C70.2705 83.5479 82.4904 102.948 85.01 101.814C87.5295 100.681 86.8996 92.8701 88.5373 91.3584C88.6633 91.3584 88.7893 91.1064 89.0412 91.1064C91.5608 90.0986 99.1195 91.1064 99.8754 89.5947C100.757 87.957 85.01 72.3359 85.01 72.3359L70.2705 83.5479Z",
    fill: "url(#paint7_linear_3986_1000)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3643 74.3516C82.3643 74.3516 96.3479 88.4609 96.8518 89.2168C97.3557 89.9726 97.3557 90.4766 97.3557 90.4766H92.6945C92.6945 90.4766 92.6945 89.9726 92.5685 89.2168C92.3166 88.4609 79.3408 76.7451 79.3408 76.7451L82.3643 74.3516Z",
    fill: "url(#paint8_linear_3986_1000)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9317 80.0215C74.9317 80.0215 87.2775 95.1386 87.2775 95.2646L86.5217 99.4219C86.5217 99.4219 75.5616 85.9424 72.1602 82.1631L74.9317 80.0215Z",
    fill: "url(#paint9_linear_3986_1000)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.167 90.9799C91.6866 89.9721 99.2452 90.9799 100.001 89.4682C99.6232 88.3344 91.9385 89.9721 90.4268 89.9721C88.915 89.9721 89.4189 90.476 89.167 90.9799Z",
    fill: "#600090"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2705 83.5488C70.2705 83.5488 82.4904 102.949 85.01 101.815C83.3722 102.319 74.5538 86.3203 70.2705 83.5488Z",
    fill: "#600090"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9 95.2636C86.7741 94.3817 83.1207 89.9726 82.6168 89.5946C82.1128 89.2167 80.6011 90.2245 80.2232 90.7284C79.9712 91.2323 85.5143 97.6572 86.0182 98.0351C86.5221 98.413 86.9 95.2636 86.9 95.2636Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.947 88.9657C93.8289 88.9657 95.4666 88.9657 95.7186 88.5878C95.9705 88.2098 91.5613 83.8007 90.5535 83.1708C89.5456 82.4149 87.404 82.7928 87.0261 83.1708C86.7741 83.5487 92.947 88.9657 92.947 88.9657Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3567 86.3183C77.7412 86.3183 87.7808 75.4892 87.7808 62.1308C87.7808 48.7725 77.7412 37.9434 65.3567 37.9434C52.9723 37.9434 42.9326 48.7725 42.9326 62.1308C42.9326 75.4892 52.9723 86.3183 65.3567 86.3183Z",
    fill: "url(#paint10_linear_3986_1000)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3196 82.5663C80.5981 80.9499 89.2414 69.6859 87.6249 57.4075C86.0084 45.1291 74.7442 36.4859 62.4657 38.1024C50.1871 39.7189 41.5438 50.9829 43.1603 63.2613C44.7768 75.5397 56.041 84.1828 68.3196 82.5663Z",
    fill: "url(#paint11_linear_3986_1000)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7813 66.0234C81.9973 58.6971 78.6652 50.1508 71.3388 46.9348C64.0124 43.7187 55.466 47.0508 52.25 54.3771C49.0339 61.7034 52.366 70.2497 59.6924 73.4657C67.0188 76.6817 75.5652 73.3497 78.7813 66.0234Z",
    fill: "url(#paint12_linear_3986_1000)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3586 74.3496C72.5944 74.3496 78.4603 68.4838 78.4603 61.248C78.4603 54.0123 72.5944 48.1465 65.3586 48.1465C58.1227 48.1465 52.2568 54.0123 52.2568 61.248C52.2568 68.4838 58.1227 74.3496 65.3586 74.3496Z",
    fill: "url(#paint13_linear_3986_1000)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4443 56.4617C60.4443 56.4617 62.082 56.4617 63.3418 53.0604C63.3418 53.0604 65.7354 51.8006 68.129 52.3045L68.6329 70.949H62.9639L62.5859 60.241L60.5703 59.9891V56.5877L60.4443 56.4617Z",
    fill: "url(#paint14_linear_3986_1000)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4443 55.077C60.4443 55.077 62.082 55.077 63.3418 51.6756C63.3418 51.6756 65.7354 50.4159 68.129 50.9198L68.6329 69.5643H62.9639L62.5859 58.8563L60.5703 58.6043V55.203L60.4443 55.077Z",
    fill: "url(#paint15_linear_3986_1000)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.311 64.0202C43.4369 65.6578 50.3657 64.0202 50.7437 63.7682C51.1216 63.5163 48.98 46.0055 65.4831 45.1237C81.9863 44.2419 80.3485 61.5006 80.4745 62.7604C80.6005 64.0202 86.3955 62.7604 87.2773 61.2487C88.2851 59.737 85.1357 37.5651 65.987 38.069C46.8384 38.5729 42.3031 53.6901 43.311 64.0202Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5157 77.8787C52.1299 75.2332 60.4445 75.7371 68.2551 74.3514C76.0658 72.9656 77.0736 68.3045 79.8451 67.4227C82.6166 66.6668 84.6323 68.5564 85.2622 69.4383C85.8921 70.3201 79.0893 80.6502 69.263 81.784C59.4367 83.0437 53.3897 77.7527 53.3897 77.7527L53.5157 77.8787Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8379 60.7442C62.8379 61.626 66.4913 60.8701 67.3732 59.7363C68.255 58.6026 67.7511 51.6739 67.7511 51.17C67.7511 50.666 63.8458 51.2959 63.4678 51.6739C63.0899 52.0518 62.334 54.3194 61.5782 54.8233C60.8223 55.3272 60.6963 55.4531 60.6963 55.9571C60.6963 56.461 60.6963 58.0987 60.8223 58.2246C60.9483 58.3506 62.586 58.2246 62.586 58.2246C62.586 58.2246 62.712 60.2403 62.8379 60.7442Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7051 73.7206C45.957 72.2089 50.7442 78.3818 57.421 81.6571C64.0979 84.9325 63.594 85.8144 63.594 86.1923C63.594 86.6962 52.3819 85.5624 45.7051 73.7206Z",
    fill: "#BD3EA9"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.688 83.547C74.1762 83.2951 77.7036 79.7677 79.8453 77.2482C81.9869 74.7287 83.8766 73.9728 85.3883 70.1935C86.9 66.4142 84.8844 79.3898 75.688 83.547Z",
    fill: "#BD3EA9"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 82.5392C62.7123 82.7912 63.4682 85.5627 63.9721 85.8146C64.3501 86.1926 71.5308 85.0588 73.1685 84.1769C74.8062 83.2951 76.6959 81.1535 76.5699 80.0197C76.318 78.8859 73.7984 82.2873 63.4682 82.5392Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7051 70.8242C45.7051 70.8242 51.878 81.6582 65.3577 81.6582C78.8373 81.6582 85.2622 70.8242 85.2622 70.8242C85.2622 70.8242 79.5932 82.4141 65.3577 82.918C51.1221 83.2959 45.7051 70.8242 45.7051 70.8242Z",
    fill: "#FFC400"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6264 55.7054C51.1225 62.2562 54.5239 49.7845 63.5943 48.6507C74.4285 47.265 76.3181 58.9808 79.0896 58.8548C81.8612 58.7289 77.2 46.0052 66.6178 45.6273C54.6499 45.2494 51.6264 55.5795 51.6264 55.5795V55.7054Z",
    fill: "#CA2790"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9014 70.0664C54.9014 70.0664 55.4053 70.8223 56.4131 71.5781C55.4053 70.6963 54.9014 70.0664 54.9014 70.0664Z",
    fill: "#FFD300"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8527 74.3506C60.6954 74.3506 57.9238 72.8389 56.4121 71.5791C58.1758 73.0908 61.4512 75.3584 65.3566 75.3584C71.4035 75.3584 76.5686 69.1855 76.5686 69.1855C76.5686 69.1855 71.9074 74.3506 64.8527 74.3506Z",
    fill: "#FFC400"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4749 81.9098C59.6877 82.0358 66.3646 77.3746 71.1517 73.5953C75.9389 69.6901 81.2299 72.5875 81.3559 73.5953C81.3559 74.6031 76.8207 81.5319 64.4749 81.9098Z",
    fill: "#E02774"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8918 38.8247C66.2384 38.5728 71.7814 44.1157 76.0647 45.6275C80.3479 47.2651 79.4661 39.3286 69.8918 38.8247Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5474 72.2091C54.3979 71.2013 56.9175 73.9728 59.941 74.4767C62.9644 74.9806 57.5474 72.2091 57.5474 72.2091Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9414 74.2246C43.9414 74.2246 44.4453 82.2871 48.0987 87.0742C51.6261 91.8613 58.0509 87.5781 58.0509 87.5781L59.4367 85.4365C59.4367 85.4365 49.4845 82.665 45.3272 72.7129L44.0674 74.2246H43.9414Z",
    fill: "#CA2790"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4043 85.3115L73.7979 88.8389C73.7979 88.8389 78.837 90.0986 83.6242 85.3115C88.4114 80.3984 86.1438 73.3437 86.1438 73.3437L85.5139 72.5879C85.5139 72.5879 80.9786 82.792 71.4043 85.1855V85.3115Z",
    fill: "#CA2790"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3986_1000",
    x: 0,
    y: 0,
    width: 129,
    height: 129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3986_1000"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3986_1000"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3986_1000",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3986_1000",
    x1: 69.8932,
    y1: 42.9837,
    x2: 69.8932,
    y2: 21.3158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A70057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3986_1000",
    x1: 63.3425,
    y1: 44.4947,
    x2: 63.3425,
    y2: 19.9293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3986_1000",
    x1: 54.1461,
    y1: 40.0859,
    x2: 62.5865,
    y2: 27.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3986_1000",
    x1: 59.1853,
    y1: 41.0928,
    x2: 71.7829,
    y2: 21.5662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3986_1000",
    x1: 45.7048,
    y1: 101.814,
    x2: 45.7048,
    y2: 72.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3986_1000",
    x1: 36.6338,
    y1: 92.3662,
    x2: 48.3496,
    y2: 74.2254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3986_1000",
    x1: 44.1924,
    y1: 99.2959,
    x2: 56.412,
    y2: 80.3993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3986_1000",
    x1: 85.0099,
    y1: 101.814,
    x2: 85.0099,
    y2: 72.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3986_1000",
    x1: 94.2062,
    y1: 92.3662,
    x2: 82.4905,
    y2: 74.2255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3986_1000",
    x1: 86.6476,
    y1: 99.2959,
    x2: 74.302,
    y2: 80.3993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFA400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3986_1000",
    x1: 73.5453,
    y1: 84.5547,
    x2: 57.1685,
    y2: 39.5809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3986_1000",
    x1: 73.0793,
    y1: 81.11,
    x2: 57.7103,
    y2: 38.9077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3986_1000",
    x1: 70.4411,
    y1: 73.6931,
    x2: 60.6151,
    y2: 46.4821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3986_1000",
    x1: 69.7678,
    y1: 73.5937,
    x2: 60.8235,
    y2: 49.0282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3986_1000",
    x1: 64.4756,
    y1: 70.8231,
    x2: 64.4756,
    y2: 52.1785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3986_1000",
    x1: 64.4756,
    y1: 69.4383,
    x2: 64.4756,
    y2: 50.7938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgRadial",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4E2280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2E1050"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourWinnerMedal);
export default __webpack_public_path__ + "static/media/tour_winner_medal.4a837a55807d394fe3ba03b869333f4e.svg";
export { ForwardRef as ReactComponent };